import { useAnalyticContext } from '../analytic_context.provider';
import { Link, LinkProps } from 'react-router-dom';
import type { ReactNode } from 'react';

interface Props extends LinkProps {
	action: string;
	to: string;
	children: ReactNode;
}

export function AnalyticLink({ to, action, children, ...rest }: Props): JSX.Element {
	const analyticCtx = useAnalyticContext();

	function handleClick(): void {
		analyticCtx.trackEvent(action);
	}

	return (
		<Link to={to} onClick={handleClick} {...rest}>
			{children}
		</Link>
	);
}
